import React from 'react';
import './ComingSoonPage.css';

const tierData = {
  wealth: {
    name: 'Wealth',
    tagline: 'Expert Guidance for Serious Investors',
    price: '₹1,499',
    priceSubtext: '/year',
    description: 'Get personalized guidance from SEBI-registered advisors combined with AI-powered portfolio analysis. Perfect for investors with ₹5-50L portfolios who want professional oversight without the premium price tag.',
    highlights: [
      {
        title: 'SEBI RIA Sessions',
        description: '1-2 structured advisory sessions per year with registered investment advisors',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        ),
      },
      {
        title: 'Goal-Based Planning',
        description: 'Custom allocation strategies aligned with your financial goals and timeline',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
          </svg>
        ),
      },
      {
        title: 'AI Pre-Analysis Pack',
        description: 'Comprehensive portfolio analysis prepared before each advisor session for maximum efficiency',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
        ),
      },
      {
        title: 'Professional PDF Reports',
        description: 'Detailed portfolio reports with actionable recommendations you can reference anytime',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
        ),
      },
    ],
    features: [
      'Everything in Lite plan',
      '1-2 SEBI RIA sessions per year',
      'Goal-based allocation plans',
      'AI-powered pre-analysis reports',
      'Priority email support',
      'Professional PDF reports',
    ],
  },
  elite: {
    name: 'Elite',
    tagline: 'Your Always-On Allocation Desk',
    price: '₹14,999',
    priceSubtext: '/year',
    description: 'The ultimate portfolio management experience for affluent investors. Continuous monitoring, multi-asset visibility, and priority access to advisors whenever you need them. Designed for portfolios of ₹50L+.',
    highlights: [
      {
        title: 'Continuous Monitoring',
        description: 'Our researchers and advisors monitor markets for you using continuously updated data-driven models, delivering proactive rebalancing recommendations',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
          </svg>
        ),
      },
      {
        title: 'Multi-Asset View',
        description: 'Unified dashboard covering mutual funds, commodities, real estate, and gold',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
        ),
      },
      {
        title: 'Priority Advisor Access',
        description: 'On-call access to SEBI-registered advisors when you need guidance most',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
        ),
      },
      {
        title: 'Family Portfolio View',
        description: 'Manage multiple PANs and track your entire family\'s wealth in one place',
        icon: (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        ),
      },
    ],
    features: [
      'Everything in Wealth plan',
      'Continuous monitoring + alerts',
      'Multi-asset portfolio view',
      'Priority advisor access on call',
      'Family portfolio (multiple PANs)',
      'Advanced stress testing',
      'Custom allocation constraints',
      'Dedicated relationship manager',
      'Quarterly portfolio review calls',
      'White-label reports',
    ],
  },
};

const ComingSoonPage = ({ tier, onBack, onClose }) => {
  const data = tierData[tier];

  if (!data) {
    return null;
  }

  return (
    <div className={`coming-soon-page ${tier}`}>
      <div className="coming-soon-overlay" onClick={onClose}></div>
      <div className="coming-soon-container">
        <div className="coming-soon-nav">
          <button className="back-button" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"></path>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Back to Plans
          </button>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="coming-soon-header">
          <div className="coming-soon-badge-large">Coming Soon</div>
          <h1>{data.name}</h1>
          <p className="coming-soon-tagline">{data.tagline}</p>
          <div className="coming-soon-price">
            <span className="price-amount">{data.price}</span>
            <span className="price-subtext">{data.priceSubtext}</span>
          </div>
        </div>

        <p className="coming-soon-description">{data.description}</p>

        <div className="coming-soon-highlights">
          <h2>Key Features</h2>
          <div className="highlights-grid">
            {data.highlights.map((highlight, index) => (
              <div key={index} className="highlight-card">
                <div className="highlight-icon">{highlight.icon}</div>
                <h3>{highlight.title}</h3>
                <p>{highlight.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="coming-soon-features">
          <h2>Full Feature List</h2>
          <ul className="features-list">
            {data.features.map((feature, index) => (
              <li key={index}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                {feature}
              </li>
            ))}
          </ul>
        </div>

        <div className="coming-soon-cta">
          <h3>Be the First to Know</h3>
          {tier === 'elite' ? (
            <p>We're working hard to bring an Elite experience to you. We invest for you — you relax and enjoy. Our team of world-class financial markets experts bring you results.</p>
          ) : (
            <p>We're working hard to bring {data.name} to you. Stay tuned for updates!</p>
          )}
          <button className="notify-button" onClick={onClose}>
            Back to App
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
